$(document).ready(function (){
    $("#table-campigns tbody").on('click', '.edit-branchOffice', function (e) {
        e.preventDefault();
        let table = $("#table-branch-offices-campaign").DataTable();
        let uuid = $(this).data('uuid')
        table.destroy()
        $("#modal-branch-offices").modal('show')

        $(".uuid_campaign").val(uuid)
        $(".modal-title-branch-office").html('Editar sucursales')
        $("#table-branch-offices-campaign").DataTable({
            proccesing: true,
            serverSide: true,
            language: {
                "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
            },
            responsive: true,
            ajax: 'get-branch-office/' + uuid,
            order: [0],
            columns: [
                {data: 'sucursal.name', name: 'sucursal.name'},
            ],
            "columnDefs": [{
                "targets": 1,
                "data": "download_link",
                "render": function (data, type, row, meta) {
                    console.log(row)
                    return '<button data-toggle="tooltip" data-placement="top" title="Eliminar sucursal" class="btn btn-danger ' +
                        'delete-sucursal-in-campaign m-1 btn-sm"' +
                        'data-id          ="' + row.campaign_id + '"  '+
                        'data-sucursal_id ="' + row.sucursal_id + '" ' +
                        '><i class="fa-solid fa-trash-can"></i></button> '
                }
            }]
        });
        $('#table-branch-offices-campaign').on('preXhr.dt', function (e, settings, data) {
            togglePreloader()
        });
        $('#table-branch-offices-campaign').on('xhr.dt', function (e, settings, json, xhr) {
            togglePreloader()
        });
    });

    $("#table-branch-offices-campaign tbody").on('click', '.delete-sucursal-in-campaign', function (e) {
        e.preventDefault()
        let id = $(this).data('id')
        let sucursal_id = $(this).data('sucursal_id')
        let uuid = $(".uuid_campaign").val()
        let route = "/delete-branch-office"
        let data = new FormData()
        data.append('id', id)
        data.append('sucursal_id', sucursal_id)
        data.append('uuid', uuid)


        Swal.fire({
            title: "¿ Esta seguro de hacer la operación ?",
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: "Sí, confirmar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: 'laproveedora_btn'
            }
        })
            .then(resultado => {
                if (resultado.value) {
                    togglePreloader()
                    $.ajax({
                        url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }, success: function (response) {
                            togglePreloader()
                            $("#table-branch-offices-campaign").DataTable().ajax.reload();
                            alertSuccess(response.msg)
                        }, error: function (errors, xhr, status,) {
                            togglePreloader()
                            var indices = errors.responseJSON.errors;
                            $.each(indices, function (index, value) {
                                $(".item-" + index).addClass('is-invalid')
                                $(".item-error-" + index).text(value);
                            });
                        }
                    })
                }
            });
    })

    $(".add-branch_id_to_campaign").on('click', function (e) {
        e.preventDefault()
        let branchId = $('#item-branch_id_sucursal_id_campaign').val();
        let uuid = $('.uuid_campaign').val();
        let data = new FormData()
        if (branchId !== '') {
            data.append('branchId', branchId)
            data.append('uuid', uuid)
            sendData(data, '/add-branch_office_to_campaign')
        }
    })

    function sendData(data, route) {
        togglePreloader();
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                if (response.type == "errorConnection") {
                    togglePreloader();
                    alertError(response.msg)
                } else if (response.type == "error") {
                    togglePreloader();
                    alertError(response.msg)
                }
                if (response.type == "success") {
                    alertSuccess(response.msg)
                    $("#table-branch-offices-campaign").DataTable().ajax.reload();
                    $("#modal-modal-branch-offices").modal('hide')
                    togglePreloader();
                }
            }, error: function (errors, xhr, status,) {
                togglePreloader();
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }
})
